import type { CBlogTranslations } from "./pl";

export const en: CBlogTranslations = {
  emptyData: "No data to display.",
  emptyList: "No posts to display.",
  readMore: "Read more ->",
  backToList: "<- Back to list",
  paginationAria: "Pagination",
  byAuthor: (name) => `Author: ${name}`,
  /** `formatDate("2026-05-13")` -> "13 May 2026". */
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
  paginationLabel: (page, totalPages) => `Page ${page} of ${totalPages}`,
  paginationHint: "Pagination will be wired up in the next iteration",
};
